import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Section, SectionHeader } from '../../common';

const ImageGallery = ({ sanity, section }) => {
  const { colors } = sanity;
  const { galleries } = section;

  // Standardize the images format
  const formatImages = (galleries) =>
    galleries?.flatMap((gallery) =>
      gallery?.images.map(({ asset, alt }) => ({
        thumb: asset?.gatsbyImageData,
        full: asset?.gatsbyImageData,
        thumbAlt: alt,
      }))
    );

  const displayedImages = formatImages(galleries);

  return (
    <Section
      idName="image-gallery"
      bgColor={colors?.neutral?.lighter}
      h2Color={colors?.neutral?.darker}
    >
      <div className="max-w-md px-4 mx-auto text-center sm:max-w-3xl lg:max-w-7xl">
        <SectionHeader
          sanity={sanity}
          tagline={section?.header?.tagline}
          headline={section?.header?.headline}
          description={section?.header?._rawDescription}
        />
        <div className="columns-1 md:columns-3 lg:columns-3">
          {displayedImages?.map((img, index) => (
            <Col
              inViewConfigMargin="100px 0px"
              key={index}
              classes="mb-4"
              onInView={(inView) =>
                console.log(`Image ${index} in view:`, inView)
              }
            >
              <div>
                <GatsbyImage
                  image={img.full}
                  alt={img.thumbAlt}
                  className="shadow-xl rounded-xl"
                  loading="eager" // Ensure images load immediately
                />
              </div>
            </Col>
          ))}
        </div>
      </div>
    </Section>
  );
};

ImageGallery.displayName = 'ImageGallery';

export { ImageGallery };
